const Card = ({img, name, desc, price}) => {

    return(
        <div className="p-3 hover:text-black text-red-900 group  shrink-0 ml-3 md:ml-6 rounded-xl hover:scale-[101%] anim">
            <div className="relative p-5 min-h-[12rem] px-0 md:p-8 shadow-xl group-hover:shadow-none rounded-xl text-center bg-white group-hover:bg-transparent anim w-fit ">
                <img  className="rounded-2xl rounded-b-none md:rounded-b-2xl drop-shadow-xl w-full md:w-[250px] h-[120px] md:h-[200px] object-cover -mt-24 group-hover:scale-[105%] anim pointer-events-auto"  alt='' src={img} />
                <div className="mb-12">
                    <h3 className="text-xl w-11/12 m-auto md:text-2xl tracking-wide mt-3 pf font-semibold">{name}</h3>
                    <p className="text-xs w-11/12 m-auto mt-1 mb-3 uppercase opacity-60">{desc}</p>
                </div>
                <button className="w-full absolute rounded-b-xl right-0 bottom-0 flex flex-col justify-center items-center p-4 py-3 bg-red-900 hover:bg-red-600 anim text-white">
                    <p className="kha text-xl md:text-2xl">₹{price}</p>
                    {/* <p className="text-xs opacity-70 font-thin ">BUY</p> */}
                </button>
            </div>
        </div>
    )
}

export default Card;